import { render } from "./App.vue?vue&type=template&id=000aa38e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=000aa38e&lang=css"

import exportComponent from "/Users/mark/Documents/vs_workspaces/sadc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__